export default __webpack_public_path__ + "static/media/washing-machine.f3d84d1e.svg";